import { Pipe, PipeTransform } from '@angular/core';
import { ProductStatus } from '../interfaces/interfaces';

@Pipe({
    name: 'productstatus'
})
export class ProductStatusPipe implements PipeTransform {
    transform(input: ProductStatus): string {
        switch (input) {
            case ProductStatus.NOT_FOR_SALE_YET: return 'Még nem árult';
            case ProductStatus.PREVIEW: return 'Előnézetes';
            case ProductStatus.FOR_SALE: return 'Árult';
            case ProductStatus.DISCONTINUED: return 'Kifutott';
            case ProductStatus.DELETED: return 'Törölt';
        }
        return '-';
    }
}